export const postConfirmationPresence = async(body) => {
  return await api("POST", "/api/confirmations/", null, body)
}

const api = async(method, path, options, body = null, maxRetries = 3) => {
  body = body || {}
  let data
  let retries = 0
  const headers = {
    "Content-Type": "application/json",
    "X-CSRFToken": window.CSRF_TOKEN,
  }
  try {
    const response = await fetch(path, {
      method: method || "GET",
      headers,
      body: method === "GET" ? undefined : JSON.stringify(body),
    })
    if (response.ok && !path.includes("format=")) {
      try {
        data = await response.json()
      } catch (e) {
        // No-op
      }
    }
    return { response, data }
  } catch (e) {
    if (retries < maxRetries) {
      retries++
      return await api(method, path, options, body, maxRetries)
    }
    return { response: { ok: false }, data: null }
  }
}
